import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import ModalComponent from '../misc/ModalComponent';
import { GetBlobFile, DownloadBlobFile, ClearBlobContent } from '../../store/BlobContainerAction';
import StatusCode from '../../util/StatusCode';
import Loading from '../misc/Loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CoreStorageContainerBlob } from '../../models/Requests';
import { RequestState } from '../../models/RequestState';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../store/store';
import { isEqual } from 'lodash';


interface BlobConnectionProps {
    blob: CoreStorageContainerBlob,
}

const BlobConnection: React.FC<BlobConnectionProps> = (props) => {
    const { t } = useTranslation(['configuration', 'common']);
    const [blob, setBlob] = useState<CoreStorageContainerBlob>(props.blob);

    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    const blobContent = useSelector<RootState, RequestState<string>>(state => state.blob.blob.content);

    useEffect(() => {
        ClearBlobContent()(dispatch);
    }, [dispatch])

    useEffect(() => {
        if (!isEqual(props.blob, blob)) {
            setTimeout(() => {
                ClearBlobContent()(dispatch);
            }, 2000)
            setBlob(props.blob)
        }
    }, [props.blob]);

    useEffect(() => {
        if (blobContent.code === StatusCode.ERROR) {
            setTimeout(() => {
                ClearBlobContent()(dispatch);
            }, 2000)
        }
    }, [blobContent.code === StatusCode.ERROR]);

    const disabled = Object.values(props.blob).some(x => x === null);

    const viewFileContent = () => {
        GetBlobFile(props.blob)(dispatch);
        setOpen(true);
    }

    const downloadBlobFile = () => {
        DownloadBlobFile(props.blob)(dispatch);
    }

    const feedbackOnClick = (status: RequestState<string>) => {
        switch (status.code) {
            case StatusCode.PENDING:
                return <Loading />;
            case StatusCode.ERROR: {
                var list = status.error.response?.data as { errors?: { [key: string]: string } };
                if (list && list.errors) {
                    const valuesList = Object.keys(list.errors).map(key => list.errors?.[key])
                    return <span><FontAwesomeIcon icon="exclamation-triangle" color="red" style={{ height: '1.5rem', marginRight: '0.5rem' }} /> {valuesList.join(', ')}</span>
                } else {
                    return <span><FontAwesomeIcon icon="exclamation-triangle" color="red" style={{ height: '1.5rem', marginRight: '0.5rem' }} />{t('error.somethingWentWrong', { ns: 'common' })}</span>
                }
            }
            default:
                return null;
        }
    }

    return (<>
        <div className="flex children-mr-3 align-items-center mt-4">
            <Button disabled={disabled} onClick={viewFileContent}>{t('moduleView.blobConnection.showFileContent', { ns: 'configuration' })}</Button>
            <Button disabled={disabled} onClick={() => downloadBlobFile()}>{t('moduleView.blobConnection.download', { ns: 'configuration' })}</Button>
            {feedbackOnClick(blobContent)}
        </div>
        {open && blobContent.code === StatusCode.COMPLETE && <ModalComponent
            isOpen={open}
            toggleModal={() => (setOpen(false))}
            header={props.blob.blobName}
            size="xl"
            cancel={t('action.close', { ns: 'common' })}
        >
            <div>
                <pre>{blobContent.data}</pre>
            </div>
        </ModalComponent>}
    </>);
}

export default BlobConnection;
